import React from "react";
import AdminLayout from "../../../components/layouts/adminLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import Dashboard from "../../../Containers/Field Executive/Dashboard";

const FEDashboard = () => {
  return (
    <AdminLayout>
      <AdminPageContainer>
        <Dashboard />
      </AdminPageContainer>
    </AdminLayout>
  );
};

export default FEDashboard;
